import { Grid } from "@material-ui/core";
import { Pagination, PaginationItem } from "@material-ui/lab";
import clsx from "clsx";
import { LynxButton } from "components/LynxButton/LynxButton";
import { observer } from "mobx-react";
import React from "react";
import { ThorPaginationProps } from "./ThorPaginationProps";
import { thorPaginationStyles } from "./ThorPaginationStyles";

export default observer(function ThorPagination(props: ThorPaginationProps) {
    const classes = thorPaginationStyles();

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        props.setPage(value);
    };

    return (
        <Grid container className={classes.root} justifyContent="center">
            <Grid item>
                <LynxButton
                    className={classes.button}
                    classes={{
                        disabled: classes.buttonDisabled,
                    }}
                    onClick={() => props.onPageChange("back")}
                    disabled={props.page <= 1}
                >
                    Prev
                </LynxButton>
            </Grid>
            <Grid item>
                <Pagination
                    count={props.pages}
                    page={props.page}
                    onChange={handleChange}
                    hideNextButton
                    hidePrevButton
                    className={classes.pagination}
                    renderItem={(item) => (
                        <div>
                            <PaginationItem {...item} />
                            <div
                                className={clsx({
                                    [classes.selected]:
                                        props.page === item.page,
                                    [classes.unselected]:
                                        props.page !== item.page,
                                })}
                            ></div>
                        </div>
                    )}
                />
            </Grid>
            <Grid item>
                <LynxButton
                    className={classes.button}
                    onClick={() => props.onPageChange("forward")}
                    disabled={props.isLastPage}
                    classes={{
                        disabled: classes.buttonDisabled,
                    }}
                >
                    Next
                </LynxButton>
            </Grid>
        </Grid>
    );
});
